module.exports = __webpack_public_path__ + "static/no_store_near_you-d2600924eca94884f7c6b3c1a5204a4f.png";